import React from 'react';
import PropTypes from 'prop-types';
import { FaCheckCircle, FaCircleNotch, FaClock, FaMinusCircle } from 'react-icons/fa';

const STATUS_CONFIG = {
  not_requested: {
    label: 'Not requested',
    Icon: FaMinusCircle,
    className: 'tw-bg-slate-100 tw-text-slate-600',
  },
  requested: {
    label: 'Requested',
    Icon: FaClock,
    className: 'tw-bg-amber-100 tw-text-amber-700',
  },
  in_progress: {
    label: 'Partially released',
    Icon: FaCircleNotch,
    className: 'tw-bg-blue-100 tw-text-blue-700',
  },
  completed: {
    label: 'Released',
    Icon: FaCheckCircle,
    className: 'tw-bg-emerald-100 tw-text-emerald-700',
  },
};

const MaterialStatusBadge = ({ status = 'not_requested', label, progressLabel }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.not_requested;
  const { Icon } = config;

  return (
    <div className="tw-flex tw-h-full tw-flex-col tw-justify-center tw-leading-tight">
      <span className={`tw-inline-flex tw-w-fit tw-items-center tw-gap-1.5 tw-rounded-xl tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-semibold ${config.className}`}>
        <Icon size={10} className="tw-shrink-0" aria-hidden="true" />
        <span>{label || config.label}</span>
      </span>
      {status !== 'not_requested' && progressLabel && (
        <span className="tw-mt-0.5 tw-text-[9px] tw-text-slate-500">{progressLabel}</span>
      )}
    </div>
  );
};

MaterialStatusBadge.propTypes = {
  status: PropTypes.string,
  label: PropTypes.string,
  progressLabel: PropTypes.string,
};

export default MaterialStatusBadge;
